import { createSlice } from '@reduxjs/toolkit'

const initState = {
    detail: null,
    distributedAt: null,
}

export const jobseekerSlice = createSlice({
    name: 'jobseeker',
    initialState: initState,
    reducers: {
        updateJobseekerDetail: (state, action) => {
            const { detail } = action.payload
            state.detail = detail
        },
        resetJobseeker: (state) => {
            state.detail = initState.detail
            state.distributedAt = initState.distributedAt
        },
        // setDistributedAt: (state, action) => {
        //     // console.log('action.payload', action.payload)
        //     // state.distributedAt = action.payload
        //     const { distributedAt } = action.payload
        //     state.distributedAt = distributedAt
        // },
        // 求職者詳細と配布日を同時に設定
        setJobSeekerWithTicket: (state, action) => {
            const { detail, distributedAt } = action.payload
            state.detail = detail
            state.distributedAt = distributedAt
        },
    },
})

export const {
    updateJobseekerDetail,
    resetJobseeker,
    // setDistributedAt,
    setJobSeekerWithTicket,
} = jobseekerSlice.actions

export const jobseekerReducer = jobseekerSlice.reducer

export const jobseekerSelector = (state) => state.jobseeker

export const getActiveJobseeker = (state) => state.jobseeker.detail